import './index.sass';
import Rails from 'rails-ujs';

const profileMessages = function() {
  const $popup = $('#message-popup');
  const $textarea = $('.message-popup__textarea');
  const $button = $('.message-popup__button');

  const $name = $('#name');
  const $email = $('#email');
  const $phone = $('#phone');

  if ($popup.length === 0) {
    return;
  }
  if ($textarea.length > 0 && $textarea.val().length === 0) {
    $('.message-popup__footer .button-casual').addClass('disabled').attr('disabled', 'disabled');
  }
  $('body').on('input', '.message-popup__textarea', function() {
    if ($(this).val().length === 0) {
      $button.addClass('disabled').attr('disabled', 'disabled');
    } else {
      $button.removeClass('disabled').removeAttr('disabled');
    }
    return true;
  });
  $button.on('click', function() {
    var form = document.querySelector('form#new-message-form');
    Rails.fire(form, 'submit');
  });
  $('#new-message-form').on('ajax:success', function(e, data) {
    $popup.addClass('sent');
    return setTimeout(function() {
      $('body').css('overflow', 'auto');
      $popup.hide();
      $('.profile-modals').fadeOut(200, function() {
        $('#new-message-form')[0].reset();
        $('.mfp-container').click();
        return $popup.removeClass('sent');
      });
      if (data !== undefined && data.error) {
        showError(data.error);
        return false;
      }
    }, 350);
  });
  return false;
};

export {profileMessages}
